<template>
    <div class="uploadBox">
        <template v-if="maxSize > 1">
            <div class="uploadStyle" v-if="state.fileList.length > 0">
                <div class="uploadBoxs" v-for="(item,index) in state.fileList" :key="index">
                    <div class="imgBox"  :style="{'width': size.width +'px','height': size.height +'px'}">
                        <template v-if="!item.loading">
                            <!-- <a-image v-if="item.status == 'success'" :src="item.url" mode="scaleToFill" @click="previewImage(index)"/> -->
                            <template v-if="props.fileType == 'img'">
                                <a-image v-if="item.status == 'success'" :src="item.url" mode="scaleToFill" @click="previewImage(index)"/>
                            </template>
                            <template v-else>
                                <video controls>
                                    <source :src="item.url" type="video/mp4">
                                    您的浏览器不支持视频
                                </video>
                            </template>
                            <div class="error" v-if="item.status == 'fail'">上传失败，请删除重新上传</div>
                            <span class="del iconfont iconshanchu" @click="del(item)"></span>
                        </template>
                        <div class="loading" v-else-if="item.loading">上传中...</div>
                        
                    </div>
                    <div class="desc" v-if="props.isInput" :style="{'width': size.width +'px'}">
                        <a-input v-model:value="item.input" placeholder="请输入" @change="e=>inputChange(e,item,index)"/>
                    </div>
                </div>
                
            </div>
            <div class="defaultStyle" v-if="state.fileList.length < maxSize ">
                <div class="uploadItem" :style="{'width': size.width +'px','height': size.height +'px'}">
                    <div class="info">
                        <span class="iconfont icon icontianjiatupian_huaban"></span>
                        <span class="text">上传{{ props.fileType == 'img' ? '图片' : '视频' }}</span>
                    </div>
                    <input class="file" type="file" @change="ChooseImage" accept="image/*" v-if="props.fileType == 'img'" multiple/>
                    <input class="file" type="file" @change="ChooseImage" accept="video/*" v-if="props.fileType == 'video'" multiple/>
                </div>
            </div>
        </template>
        <template v-if="maxSize === 1">
            <div class="defaultStyle">
                <div class="uploadItem" :style="{'width': size.width +'px','height': size.height +'px'}" v-if="state.fileList.length === 0">
                    <div class="info">
                        <span class="iconfont icon icontianjiatupian_huaban"></span>
                        <span class="text">上传{{ props.fileType == 'img' ? '图片' : '视频' }}</span>
                    </div>
                    <input class="file" type="file" @change="ChooseImage" accept="image/*" v-if="props.fileType == 'img'"/>
                    <input class="file" type="file" @change="ChooseImage" accept="video/*" v-if="props.fileType == 'video'"/>
                </div>
                <div class="picture" v-else>
                    <div class="uploadBoxs" v-for="(item,index) in state.fileList" :key="index">
                        <div class="imgBox" :style="{'width': size.width +'px','height': size.height +'px'}">
                            <template v-if="!item.loading">
                                <template v-if="props.fileType == 'img'">
                                    <a-image v-if="item.status == 'success'" :src="item.url" mode="scaleToFill" @click="previewImage(index)"/>
                                </template>
                                <template v-else>
                                    <video controls>
                                        <source :src="item.url" type="video/mp4">
                                        您的浏览器不支持视频
                                    </video>
                                </template>
                                <div class="error" v-if="item.status == 'fail'">上传失败，请删除重新上传</div>
                                <span class="del iconfont iconshanchu" @click="del(item)"></span>
                            </template>
                            <div class="loading" v-else>上传中...</div>
                        </div>
                        <div class="desc" v-if="props.isInput" :style="{'width': size.width +'px'}">
                            <a-input v-model:value="item.input" placeholder="请输入" @change="e=>inputChange(e,item,index)"/>
                        </div>
                    </div>

                </div>
            </div>
        </template>
        <a-modal class="systemModalStyle" :maskClosable="false" :visible="state.previewVisible" title="预览" :footer="null" @cancel="state.previewVisible = false" :destroyOnClose="true">
            <img alt="example" style="width: 100%" :src="state.previewImage" />
        </a-modal>
        <!-- <ImageCropper v-model:visible="imageVisible" :imgPath="cropperImg" :width="getSize('width')" :height="getSize('height')" @saveImg="saveImg"/> -->

    </div>
    
</template>
<script setup>
import { reactive, ref,toRefs } from "vue";
import { PlusOutlined, LoadingOutlined,UserOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import {storeUploader,uploadVideo,uploadImage} from '@/api/base.js'
import common from '@/utils/common.js'
import Compressor from 'compressorjs';
const props = defineProps({
    name:{
        type: String,
        default: ''
    },
    type:{
        type: String,
        default: ''
    },
    maxSize:{
        type: Number,
        default: 1
    },
    size:{
        type:Object,
        default:{}
    },
    fileType:{
        type: String,
        default: 'img'
    },
    isInput:{
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['uploadSuccess','del','uploadInputSuccess'])
const state = reactive({
    fileList: [],
    maxSize:10,
    previewVisible:false,
    previewImage: null,
    imageUrl: null
})



const ChooseImage = async(e)=>{
    let files = e.target.files
    console.log(files,'files')
    for(var i=0;i<files.length;i++){
        let item = files[i]
        let result = null
        if((item.size >= 2 * 1024 * 1024) && props.fileType == 'img') {
            result = await handleImg(item)
        }else{
            result = item
        }
        console.log(result,'res')
        state.fileList.push({
            loading: true,
            status: 'loading',
            index: state.fileList.length - 1
        })
        try{
            let res = await uploadImg(result)
            state.fileList[state.fileList.length - 1] = {
                ...state.fileList[state.fileList.length - 1],
                url: common.base + common.baseUrl + res.value,
                loading: false,
                status: 'success',
                origin: res.value
            }
            emits('uploadSuccess',res.value)
        }catch(err){
            state.fileList[state.fileList.length - 1] = {
                ...state.fileList[state.fileList.length - 1],
                loading: false,
                status: 'fail',
            }
        }
    }
    console.log(state.fileList,'file')
}

const del = (item)=>{
    state.fileList = state.fileList.filter(child => child !== item)
    emits('del', item)
}

const uploadImg = async(file)=>{
    return await new Promise((resolve, reject) => {
        let formdata = new FormData()
        formdata.append('file', file);
        if(props.name == 'store') formdata.append('type', props.type);
        let api = ''
        if(props.name == 'store') api = storeUploader(formdata)
        else if(props.name == 'postImg') api = uploadImage(formdata)
        else if(props.name == 'postVideo') api = uploadVideo(formdata)
        if(api){
            api.then(res=>{
                console.log(res,'res')
                resolve(res.data)
            }).catch(err=>{
                if(err.response.status == 413){
                    message.error('图片太大,请更换图片上传')
                    reject({
                        message:'图片太大导致上传不了'
                    })
                }
                
            })
        }
    })
}

const  blobToFile = (blob)=> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function() {
            const dataUrl = reader.result;
            const mime = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            let binary = atob(dataUrl.split(",")[1]);
            let array = [];
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            const file = new File([new Uint8Array(array)], blob.name, {
                type: mime
            });
            resolve(file);
        };

        reader.onerror = function() {
            reject("Failed to convert blob to file.");
        };

        reader.readAsDataURL(blob);
    });
}

const handleImg = async(item)=>{
    return await new Promise((resolve, reject) => {
        let data = null
        new Compressor(item, {
            quality: 0.6, // 压缩质量
            mimeType: 'image/jpeg',
            success: async(result) => {
                blobToFile(result).then(file=>{
                    data = file
                    data.path = URL.createObjectURL(file)
                    resolve(data)
                })
            },
            error: (err) => {
                console.log(err.message);
                reject(err)
            }
        })
    })
}

const inputChange = (e,item,index)=>{
    console.log(e,item,1111)
    emits('uploadInputSuccess',item,index)
}

defineExpose({
    ...toRefs(state),
})
</script>
<style lang="less" scoped>
@import url('@/assets/css/theme.less');
.uploadImg{
    width: 104px;
    height: 104px;
    object-fit: contain;
}
.review{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    .del{
        width: 60px;
        height: 60px;
        background: @color-red;
        position: absolute;
        top: -30px;
        right: -30px;
        transform: rotate(45deg);
        cursor: pointer;
        z-index: 101;
        .icon{
            font-size: @font-size-big;
            color: @color-white;
            transform: rotate(-45deg);
            position: absolute;
            bottom: 1px;
            left: 24px;
        }
    }
    &.avatarView{
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
        .emptyImg-text{
            position: absolute;
            left: 0;
            width: 100%;
            bottom: 0;
            background: @color-gray;
            color: @color-white;
            line-height: 30px;
        }
    }
}
.emptyImg{
    width: 100%;
    height: 100%;
    .emptyInfo{
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
        .icon{
            width: 100%;
            height: 100%;
            background: @color-active;
            color: @color-white;
            border-radius: 50%;
            font-size: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                margin-bottom: 20px;
            }
        }
        .emptyImg-text{
            position: absolute;
            left: 0;
            width: 100%;
            bottom: 0;
            background: @color-gray;
            color: @color-white;
            line-height: 30px;
        }
    }
    &.normalUplaod{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
}
.defaultStyle{
    .uploadItem{
        border: 1px solid #eee;
        background: #f5f5f5;
        display: inline-block;
        position: relative;
        .file{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
        }
        .info{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .icon{
                font-size: 40px;
                line-height: 30px;
                margin-top: 5px;
            }
            .text{
                display: block;
                margin: 10px 0 0 0;
            }
            color: #999;
            
        }
    }
    
}
.uploadBoxs{
    display: inline-block;
    .desc{
        margin-bottom: 10px;
    }
}
.imgBox{
    border: 1px solid #eee;
    // padding: 4px;
    position: relative;
    display: inline-block;
    margin: 0 10px 10px 0;
    vertical-align: top;
    .del{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 17px;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
        &::after{
            content: '';
            width: 36px;
            height: 36px;
            position: absolute;
            background: linear-gradient(225deg, red, red 50%, transparent 50%, transparent 100%);
            right: 0;
            top: 0;
        }
        &::before{
            position: absolute;
            z-index: 1;
            right: 1px;
            top: 1px;
        }
    }
    // &:nth-child(3n){
    //     margin-right: 0;
    // }
}
.uploadStyle,
.defaultStyle{
    display: inline;
    vertical-align: top;
}
.loading,
.error{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
video{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>